import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import {
  MitsFormSelectControlValueAccessorDirective
} from './mits-form-select-control-value-accessor.directive';
import {
  MitsFormSelectComponent
} from './mits-form-select.component';

@NgModule({
  imports: [
    CommonModule,
    IonicModule,
    ReactiveFormsModule
  ],
  declarations:
    [MitsFormSelectComponent,
      MitsFormSelectControlValueAccessorDirective
    ],
  exports: [
    MitsFormSelectComponent,
    MitsFormSelectControlValueAccessorDirective
  ],
})
export class MitsFormSelectModule {
}